import type { RouteRecordRaw, Router } from 'vue-router'
import { PageOutputDto, queryPagesReq } from '@/api/menu'
import BaseView from '@/views/BaseView.vue'

const NOT_FOUND_ROUTE: RouteRecordRaw = {
  path: '/:pathMatch(.*)*',
  name: 'NotFound',
  component: () => import('@/views/NotFoundView.vue'),
  meta: { title: 'notFound.title', hidden: true }
}

function transformRoutes(routes: PageOutputDto[]): RouteRecordRaw[] {
  return routes.map((route) => {
    const record = {
      path: route.pageCode,
      name: route.pageName,
    } as RouteRecordRaw
    record.component = BaseView
    record.meta = { title: route.pageName, breadcrumb: route.pageName }
    return record
  })
}

export async function addDynamicRoutes(router: Router): Promise<RouteRecordRaw[]> {
  const pages = await queryPagesReq()

  const routes = transformRoutes(pages.data.result.pageList.filter((item) => {
    if (!item.pageCode) return false
    if (!item.pageCode.startsWith('/')) return false
    return true
  }))

  const existingPaths = router.getRoutes().map((r) => r.path)
  routes.forEach((route) => {
    if (!existingPaths.includes(route.path)) {
      router.addRoute('Root', route)
    }
  })

  // 404 通配符必须在所有业务路由之后注册
  if (!router.hasRoute('NotFound')) {
    router.addRoute(NOT_FOUND_ROUTE)
  }

  return [...routes]
}
